import classNames from 'classnames';
import { Outlet, useLocation } from 'react-router-dom';

import FiveGsAuthBackdrop from '@/components/FiveGsAuthBackdrop';

import styles from './index.module.scss';

const AppLayout = () => {
  const { pathname } = useLocation();
  const isAccountActivation = pathname === '/continue/password';

  return (
    <div
      className={classNames(styles.authExperience, {
        [styles.activationExperience]: isAccountActivation,
      })}
    >
      <FiveGsAuthBackdrop />

      <div className={styles.scrim} />

      <main
        className={classNames(styles.authModal, {
          [styles.activationPanel]: isAccountActivation,
        })}
      >
        <div className={styles.accent} />

        {isAccountActivation && (
          <header className={styles.activationHeader}>
            <div className={styles.activationEyebrow}>WELCOME TO 5GS LAB</div>
            <h1>Activate your account</h1>
            <p>
              Create your password to complete your 5GS Lab account setup.
            </p>
          </header>
        )}

        <Outlet />
      </main>
    </div>
  );
};

export default AppLayout;
